import { useTheme } from '@emotion/react';
import { IconName } from '../icons';
import { themeCss } from './theme-css';

export * from './colors';

export type AuraTheme = {
  css: string;
  icons: {
    checkBox: IconName;
    flashMessageClose: IconName;
    flashMessageDefault: IconName;
    flashMessageError: IconName;
    flashMessageSuccess: IconName;
    flashMessageWarning: IconName;
    selectDropdown: IconName;
  };
};

const ProTheme: AuraTheme = {
  css: themeCss,
  icons: {
    checkBox: IconName.TW_PRO_CHECK_MARK,
    flashMessageClose: IconName.TW_PRO_CLOSE,
    flashMessageDefault: IconName.TW_PRO_SORT,
    flashMessageError: IconName.TW_PRO_CAUTION,
    flashMessageSuccess: IconName.TW_PRO_CHECK_MARK,
    flashMessageWarning: IconName.TW_PRO_WARNING_OUTLINE,
    selectDropdown: IconName.TW_PRO_CHEVRON_DOWN,
  },
};

const FALLBACK_ICON = IconName.TW_PRO_QUESTION;

export function useIcon(location: keyof AuraTheme['icons']): IconName {
  const theme = useTheme() as Partial<AuraTheme>;
  return theme.icons?.[location] || FALLBACK_ICON;
}

export enum ThemeName {
  TW_PRO = 'TW_PRO',
}

export async function loadTheme(theme: ThemeName): Promise<AuraTheme> {
  switch (theme) {
    case ThemeName.TW_PRO:
      return ProTheme;
  }
}
